import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const DashboardApi = createApi({
  reducerPath: "dashboard",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND2_URL}/v1`,
    credentials: "include",
  }),
  endpoints: (builder) => ({
    getAllDashboards: builder.query({
      query: () => "/dashboards",
    }),

    createDashboard: builder.mutation({
      query: (val) => ({
        url: "/dashboards",
        method: "POST",
        body: val,
      }),
    }),

    editDashboard: builder.mutation({
      query: ({ id, val }) => ({
        url: `/dashboards/${id}`,
        method: "PATCH",
        body: val,
      }),
    }),

    deleteDashboard: builder.mutation({
      query: (val) => ({
        url: `/dashboards/${val}`,
        method: "DELETE",
        body: val,
      }),
    }),

    getAllDashboardsWidgets: builder.query({
      query: ({ id }) => `/dashboards/${id}/widgets`,
    }),

    editDashboardWidgets: builder.mutation({
      query: ({ id, val }) => ({
        url: `/widgets/${id}`,
        method: "PATCH",
        body: { position: val },
      }),
    }),
    deleteDashboardWidgets: builder.mutation({
      query: (val) => ({
        url: `/widgets/${val}`,
        method: "DELETE",
        body: val,
      }),
    }),
    createWidget: builder.mutation({
      query: ({ id, val }) => ({
        url: `/dashboards/${id}/widgets/replace`,
        method: "POST",
        body: { widgets: val },
      }),
    }),
    getSingleWidget: builder.query({
      query: ({ id }) => `/widgets/${id}`,
    }),

    getMapData: builder.query({
      query: () => "/getTrackingMapData",
    }),
    getDistanceCoverageData: builder.query({
      query: ({ offset, limit }) =>
        `/getDistanceCoverageData?offset=${offset}&limit=${limit}`,
    }),
    getEngineHoursData: builder.query({
      query: ({ offset, limit }) =>
        `/getEngineHoursData?offset=${offset}&limit=${limit}`,
    }),
    getSpeedDetails: builder.query({
      query: ({ offset, limit }) =>
        `/getSpeedDetails?offset=${offset}&limit=${limit}`,
    }),
    getVehicleDetails: builder.query({
      query: ({ offset, limit }) =>
        `/getVehiclesDetails?offset=${offset}&limit=${limit}`,
    }),
    getVehicleStatus: builder.query({
      query: ({ status, page, pageSize, sortBy, sortOrder, search }) => {
        const sortby = sortBy ? `&sortBy=${sortBy}` : "";
        const sortorder = sortBy ? `&sortOrder=${sortOrder}` : "";
        const searchQuery = search ? `&search=${search}` : "";
        return `/vehicle-status/${status}?page=${page}&pageSize=${pageSize}${sortby}${sortorder}${searchQuery}`;
      },
    }),
    getAbsentIdleStaff: builder.query({
      query: ({ page, limit, filterBy }) => {
        const filter = filterBy ? `&fieldStaffState=${filterBy}` : "";
        return `/dashboard/idle-absent?${`&page=${page}&limit=${limit}${filter}`}`;
      },
    }),
    getFormMetrics: builder.query({
      query: ({ page, limit, filterBy, from, to }) => {
        const filter = filterBy ? `&status=${filterBy}` : "";
        const fromQuery = from ? `&fromDate=${from}` : "";
        const toQuery = to ? `&toDate=${to}` : "";
        return `/dashboard/form-metrics?${`&page=${page}&limit=${limit}${filter}${fromQuery}${toQuery}`}`;
      },
    }),
    getTaskAlerts: builder.query({
      query: ({ page, limit, filterBy, isDelayed }) => {
        const filter = filterBy ? `&status=${filterBy}` : "";
        const isDelayedQuery = isDelayed ? `&isDelayed=${isDelayed}` : "";
        return `/dashboard/task-alerts?${`&page=${page}&limit=${limit}${filter}${isDelayedQuery}`}`;
      },
    }),
    getTaskDistributionByStatus: builder.query({
      query: ({ page, limit, status }) =>
        `/dashboard/daily-fieldStaff-Status?page=${page}&limit=${limit}&status=${status}`,
    }),
  }),
});

export const {
  useGetAllDashboardsQuery,
  useCreateDashboardMutation,
  useEditDashboardMutation,
  useDeleteDashboardMutation,
  useGetAllDashboardsWidgetsQuery,
  useLazyGetAllDashboardsWidgetsQuery,
  useEditDashboardWidgetsMutation,
  useDeleteDashboardWidgetsMutation,
  useCreateWidgetMutation,
  useLazyGetSingleWidgetQuery,
  useGetMapDataQuery,
  useLazyGetDistanceCoverageDataQuery,
  useLazyGetEngineHoursDataQuery,
  useLazyGetSpeedDetailsQuery,
  useLazyGetVehicleDetailsQuery,
  useLazyGetVehicleStatusQuery,
  useGetAbsentIdleStaffQuery,
  useGetFormMetricsQuery,
  useGetTaskAlertsQuery,
  useGetTaskDistributionByStatusQuery,
} = DashboardApi;
